import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getUsersByType = async (page, pageSize, userType) => {
  const builder = new UrlBuilder(`/admin/users`);

  // builder.add('page', page);
  // builder.add('pageSize', pageSize);
  // builder.add('userType', userType);

  try {
    const response = await post(builder.toString(), { page, pageSize, userType });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const userPromote = async (payload) => {
  const builder = new UrlBuilder(`/admin/users/promote`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const userDemote = async (payload) => {
  const builder = new UrlBuilder(`/admin/users/demote`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
